import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    dogtag: 'v1.2',
    api: 'http://gmsnext.qa-events.idonatedev.com/events-api',
    google: '',
    sdkConfig: {},
    embed: {
      scriptUrl: '',
      givingFormScriptUrl: '',
    },
    recaptchaKey: '',
  },
  mutations: {
    api(state, evt) {
      state.api = evt;
    },
    google(state, page) {
      state.google = page;
    },
    sdkConfig(state, config) {
      state.sdkConfig = config;
    },
    configureEmbed(state, config) {
      state.embed = {...config};
    },
    recaptchaKey(state, key) {
      state.recaptchaKey = key;
    },
  },
  getters: {
    dogtag: (state) => {
      return state.dogtag;
    },
    api: (state) => {
      return state.api;
    },
    google: (state) => {
      return state.google;
    },
    embed: (state) => {
      return state.embed;
    },
    sdkConfig: (state) => {
      return state.sdkConfig;
    },
    recaptchaKey: (state) => {
      return state.recaptchaKey;
    },
  },
  actions: {
  },
});
